/**
 * Normalize phone number to +48XXXXXXXXX format
 * Matches backend normalization logic in apps/common/utils.py
 * @param {string} rawPhone - Raw phone number input
 * @returns {string} Normalized phone number
 */
export const normalizePhoneNumber = (rawPhone) => {
  if (!rawPhone) return '';
  
  // Remove all non-digit characters
  const digits = rawPhone.replace(/\D/g, '');
  
  // Apply normalization rules (matching backend logic)
  if (digits.startsWith('48') && digits.length === 11) {
    return `+${digits}`;
  } else if (digits.startsWith('0') && digits.length === 10) {
    return `+48${digits.substring(1)}`;
  } else if (digits.length === 9) {
    return `+48${digits}`;
  } else if (digits.startsWith('48') && digits.length === 9) {
    return `+48${digits.substring(digits.length - 9)}`;
  } else if (rawPhone.startsWith('+48') && digits.length === 11) {
    return rawPhone;
  } else if (digits.length >= 9) {
    return `+48${digits.substring(digits.length - 9)}`;
  }
  
  return rawPhone;
};

/**
 * Format phone number for display
 * @param {string} phone - Phone number to format
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  const normalized = normalizePhoneNumber(phone);
  
  // Format as +48 XXX XXX XXX
  if (normalized.startsWith('+48') && normalized.length === 12) {
    return `${normalized.substring(0, 3)} ${normalized.substring(3, 6)} ${normalized.substring(6, 9)} ${normalized.substring(9)}`;
  }
  
  return normalized;
};
